/*
 * Reporter pipes module
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnumDisplayValuePipe } from 'app/shared/pipes/enumDisplayValue.pipe';

@NgModule ( {
  declarations: [
    EnumDisplayValuePipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    EnumDisplayValuePipe,
  ]
} )
export class PipesModule {}
